// Runtime feature collection for active `.luis` source elements.
// It keeps debug/map/performance behavior stable while enabling worker opt-in.
import type { LuisRuntimeFeatureName } from '../../features'
import type { LuisSourceElement } from '../context'
import { readLuisRuntimeOptions } from '../options'

// Collect runtime features requested by active source nodes.
export function collectRequestedRuntimeFeatures(sources: LuisSourceElement[]): Set<LuisRuntimeFeatureName> {
  const requested = new Set<LuisRuntimeFeatureName>()
  // Read data-luis options from each source element in DOM order.
  for (const source of sources) {
    const options = readLuisRuntimeOptions(source)
    if (options.debug) {
      requested.add('debug')
    } else {
      // Continue feature checks when debug is disabled.
    }
    if (options.performance) {
      requested.add('performance')
    } else {
      // Continue feature checks when performance is disabled.
    }
    if (options.map) {
      requested.add('map')
    } else {
      // Continue feature checks when map is disabled.
    }
    if (options.lazy) {
      requested.add('lazy')
    } else {
      // Continue feature checks when lazy observed mode is disabled.
    }
    if (options.worker === 'worker') {
      requested.add('worker')
    } else {
      // Continue feature checks when worker is not explicitly forced.
    }
  }

  // Return aggregate requested feature set.
  return requested
}
